export default __webpack_public_path__ + "static/event9-d2f95e8f9fa73a564eb7dfb21017fef5.jpg";